/**
 * Проверяет и корректирует значение периода
 * Значение должно входить в possiblePeriods
 */
export const preparePeriod = (period: string | string[], possiblePeriods: string[]) => {
  if (!period || !possiblePeriods.length) {
    return;
  }

  const periodAsString = typeof period === 'string' ? period : period[0];

  if (!possiblePeriods.includes(periodAsString)) {
    return;
  }

  return periodAsString;
};
